import { c as _c } from "react/compiler-runtime";
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';
import css from './Label.module.css';
export type LabelProps = PropsWithChildren<{
  htmlFor: string;
  error?: boolean;
  gutterBottom?: boolean;
  className?: string;
}>;
const Label: FC<LabelProps> = t0 => {
  const $ = _c(8);
  const {
    htmlFor,
    error,
    gutterBottom,
    className,
    children
  } = t0;
  const t1 = error && css.error;
  const t2 = gutterBottom && css.gutterBottom;
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = clsx(css.root, t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== htmlFor || $[6] !== t3) {
    t4 = <Typography component="label" variant="subtitle1" htmlFor={htmlFor} className={t3}>{children}</Typography>;
    $[4] = children;
    $[5] = htmlFor;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default Label;